import type {
  DemoDataResetMembershipCandidate,
  DemoDataResetResponse,
} from "../../../../../../../../../../../../../../../api/kehrblatt/demo-data"

export type DemoResetStepId = "primary" | "secondary" | "reset"
export type DemoResetMemberRole = "primary" | "secondary"

/** One existing membership selected by its current revision; nothing about it is changed. */
export type DemoResetMemberOutput = {
  membershipId: string
  membershipRevision: number
  displayName: string
  username: string
}

export type DemoResetOutput = {
  result: DemoDataResetResponse
  downloadedFiles: ["admin", "employee"]
}

export type DemoResetWorkflowOutputs = {
  primary?: DemoResetMemberOutput
  secondary?: DemoResetMemberOutput
  reset?: DemoResetOutput
}

export type DemoResetWorkflowEvent =
  | { type: "member_selected"; role: DemoResetMemberRole; output: DemoResetMemberOutput }
  | { type: "member_edit_requested"; role: DemoResetMemberRole }
  | { type: "street_lists_downloaded"; result: DemoDataResetResponse }

export type DemoResetRunPhase =
  | "ready"
  | "enqueueing"
  | "running"
  | "status_unavailable"
  | "succeeded_waiting_download"
  | "failed"
  | "downloaded"

export const memberOutputFromCandidate = (
  candidate: DemoDataResetMembershipCandidate,
): DemoResetMemberOutput => ({
  membershipId: candidate.membership_id,
  membershipRevision: candidate.membership_revision,
  displayName: candidate.display_name,
  username: candidate.username,
})
